import { FeatureFlag, featureFlagsStore } from '~/modules/stores/feature_flags_store';

export const FeatureFlags = {
    get FF_OTHER_APPS_LIKE_THIS(): boolean {
        return withLocalStorageOverride('FF_OTHER_APPS_LIKE_THIS', isEnabled('ace-other-apps-like-this'));
    },
    get FF_UNIFIED_DOMAINS(): boolean {
        return withLocalStorageOverride('FF_UNIFIED_DOMAINS', isEnabled('ace-unified-domains'));
    },
    get FF_GA4_ANALYTICS(): boolean {
        return withLocalStorageOverride('FF_GA4_ANALYTICS', isEnabled('discovery-ga4-analytics'));
    },
    get FF_CUSTOMER_CONSOLE(): boolean {
        return withLocalStorageOverride('FF_CUSTOMER_CONSOLE', isEnabled('customer-console'));
    },
    get FF_FILTER_COPILOT_SOLUTONS(): boolean {
        return withLocalStorageOverride('FF_FILTER_COPILOT_SOLUTONS', isEnabled('ace-copilot-solutions'));
    },
    get FF_SALES_PROGRAM_FILTER(): boolean {
        return withLocalStorageOverride('FF_SALES_PROGRAM_FILTER', isEnabled('discovery-sales-programs-filter'));
    },
    get FF_MA_NEW_TRAFFIC_SOURCES(): boolean {
        return withLocalStorageOverride('FF_MA_NEW_TRAFFIC_SOURCES', isEnabled('discovery-ma-new-traffic-sources'));
    },
    get FF_JAPANESE_SITE_LEARN_TAB(): boolean {
        return withLocalStorageOverride('FF_JAPANESE_SITE_LEARN_TAB', isEnabled('discovery-learn-tab-jp'));
    },
    get FF_AGENTFORCE_CHAT_BUTTON(): boolean {
        // Local storage override is intentionally avoided here because
        // this feature flag should always be controlled by remote configuration.
        return isEnabled('discovery-agentforce');
    },
    get FF_EXPLORE_AGENTFORCE_PAGE(): boolean {
        return withLocalStorageOverride('FF_EXPLORE_AGENTFORCE_PAGE', isEnabled('discovery-explore-page-agentforce'));
    },
    get FF_DISABLE_AUTO_LOAD_QUALIFIED_CHAT(): boolean {
        return withLocalStorageOverride(
            'FF_DISABLE_AUTO_LOAD_QUALIFIED_CHAT',
            isEnabled('discovery-disable-auto-load-qualified-chat'),
        );
    },
    get FF_USE_HYBRID_SEARCH_ENGINE(): boolean {
        return withLocalStorageOverride('FF_USE_HYBRID_SEARCH_ENGINE', isEnabled('use-hybrid-search-engine'));
    },
};

function isEnabled(featureFlag: FeatureFlag, defaultValue = false) {
    return featureFlagsStore.getState().featureFlags[featureFlag] ?? defaultValue;
}

function withLocalStorageOverride(featureFlagName: string, defaultValue = false) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const override = globalThis.localStorage?.getItem(featureFlagName) ?? null;
    if (override == null) {
        return defaultValue;
    }
    return override === 'true';
}
